import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = "Calculatrice racine - Calculez les racines carrées et cubiques";
const DESCRIPTION =
  "Calculatrice racine - Calculez les racines carrées et cubiques pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "racine les racines carrées et cubiques, calculatrice racine les racines carrées et cubiques, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/roots";
function RootCalculator() {
  const [xRoot1, setXRoot1] = useState(0);
  const [xRoot2, setXRoot2] = useState(0);
  const [xRoot3, setXRoot3] = useState(0);
  const [nRoot, setNRoot] = useState(0);
  const [results, setResults] = useState({});

  const handleCalculate = () => {
    const sqr = Math.sqrt(xRoot1);
    const cbr = Math.cbrt(xRoot2);
    const nthRoot = Math.pow(xRoot3, 1 / nRoot);
    setResults({
      squareRoot: sqr.toFixed(4),
      cubicRoot: cbr.toFixed(4),
      nthRoot: isFinite(nthRoot) ? nthRoot.toFixed(4) : "N/A"
    });
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice racine offre une interface facile à utiliser pour calculer les racines pour n'importe quel nombre. Cela permet aux utilisateurs de comprendre comment calculer les racines, qu'elles soient carrées, cubiques ou tout autre type.
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  Guide de calcul des racines
                </h2>
                <ul>
                  <li>
                    La valeur sous la racine est élevée à la puissance 1 divisée par la valeur de la racine, ce qui signifie:
                  </li>
                  <li>
                    Résultat = valeur sous racine^(1/valeur racine)
                    <br />y = x^(1/n)
                  </li>
                  <li>Remarque : il n'y a pas de racines pour les valeurs négatives</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <h3 style={{ fontSize: "14px" }}>Racine carrée</h3>
                  <div className="form-group">
                    <input
                      type="number"
                      value={xRoot1}
                      onChange={(e) => setXRoot1(e.target.value)}
                      className="form-control"
                      placeholder="Entrez un nombre"
                    />
                  </div>

                  <h3 style={{ fontSize: "14px" }}>Racine cubique</h3>
                  <div className="form-group">
                    <input
                      type="number"
                      value={xRoot2}
                      onChange={(e) => setXRoot2(e.target.value)}
                      className="form-control"
                      placeholder="Entrez un nombre"
                    />
                  </div>

                  <h3 style={{ fontSize: "14px" }}>Nième racine</h3>
                  <div className="form-group">
                    <label>Nombre:</label>
                    <input
                      type="number"
                      value={xRoot3}
                      onChange={(e) => setXRoot3(e.target.value)}
                      className="form-control"
                      placeholder="Nombre"
                    />
                  </div>
                  <div className="form-group">
                    <label>Racine (n):</label>
                    <input
                      type="number"
                      value={nRoot}
                      onChange={(e) => setNRoot(e.target.value)}
                      className="form-control"
                      placeholder="Racine"
                    />
                  </div>

                  <button
                    className="btn btn-success"
                    onClick={handleCalculate}
                  >
                    Calculer
                  </button>
                </div>

                <br />
                {Object.keys(results).length > 0 && (
                  <div>
                    <p className="p-3 mb-2 bg-success text-white">
                      Racine carrée de {xRoot1}: {results.squareRoot}
                    </p>
                    <p className="p-3 mb-2 bg-success text-white">
                      Racine cubique de {xRoot2}: {results.cubicRoot}
                    </p>
                    <p className="p-3 mb-2 bg-success text-white">
                      Racine {nRoot} de {xRoot3}: {results.nthRoot}
                    </p>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Calculatrice de racines — racine carrée et cubique</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        La racine n-ième d'un nombre a est la valeur b telle que bⁿ = a.
                        Racine carrée : √49 = 7 (car 7² = 49).
                        Racine cubique : ∛27 = 3 (car 3³ = 27).
                      </p>
                      <p>
                        Pour les racines non entières, la méthode d'estimation
                        de Newton-Raphson est utilisée. Exemple : ∛125 ≈ 5 (exact),
                        ∛126 ≈ 5,013 par itération.
                      </p>
                      <p>
                        Cette calculatrice permet de calculer toute racine n-ième
                        en entrant la valeur et l'indice de la racine souhaitée.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default RootCalculator;
